import { useTranslation } from 'react-i18next'

/** Короткая подпись лота Carlink для карточки канбана и таблицы лидов. */
const LOT_LABEL: Record<string, string> = {
  DRAFT: 'DRAFT',
  MODERATED: 'MODERATED',
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
  SUCCESS: 'FINISHED',
  BUYNOW: 'FINISHED',
  FAILED: 'FAILED',
}

const LOT_CLASSES: Record<string, string> = {
  none: 'border-[rgba(255,255,255,0.08)] bg-[rgba(255,255,255,0.05)] text-[color:var(--stryzh-color-text-secondary)]',
  DRAFT: 'border-sky-500/30 bg-sky-500/10 text-sky-300',
  MODERATED: 'border-sky-500/30 bg-sky-500/10 text-sky-300',
  ACTIVE: 'border-yellow-500/30 bg-yellow-500/10 text-yellow-300',
  FINISHED: 'border-green-500/30 bg-green-500/10 text-green-300',
  FAILED: 'border-rose-500/30 bg-rose-500/10 text-rose-300',
}

/** Бейдж лота Carlink: «не создан», черновик, модерация, торги, завершён, не продан.
 *  Неизвестный статус моста показываем как есть. */
export function LotBadge({ status }: { status: string | null | undefined }) {
  const { t } = useTranslation()
  const key = status ? (LOT_LABEL[status] ?? null) : 'none'
  const label = key ? t(`leads.lot.${key}`) : status
  return (
    <span
      className={
        'inline-flex shrink-0 items-center rounded-[100px] border px-2 py-0.5 ' +
        'font-[family-name:var(--stryzh-font-family-inter)] text-[length:var(--stryzh-font-size-xs)] ' +
        'font-medium uppercase tracking-[0.5px] ' +
        (LOT_CLASSES[key ?? ''] ?? LOT_CLASSES.none)
      }
    >
      {label}
    </span>
  )
}
